function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import SparkMD5 from "spark-md5";
var fileSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
export var FileChecksum = /*#__PURE__*/function () {
  function FileChecksum(file) {
    _classCallCheck(this, FileChecksum);

    this.file = file;
    this.chunkSize = 2097152; // 2MB

    this.chunkCount = Math.ceil(this.file.size / this.chunkSize);
    this.chunkIndex = 0;
  }

  _createClass(FileChecksum, [{
    key: "create",
    value: function create(callback) {
      var _this = this;

      this.callback = callback;
      this.md5Buffer = new SparkMD5.ArrayBuffer();
      this.fileReader = new FileReader();
      this.fileReader.addEventListener("load", function (event) {
        return _this.fileReaderDidLoad(event);
      });
      this.fileReader.addEventListener("error", function (event) {
        return _this.fileReaderDidError(event);
      });
      this.readNextChunk();
    }
  }, {
    key: "fileReaderDidLoad",
    value: function fileReaderDidLoad(event) {
      this.md5Buffer.append(event.target.result);

      if (!this.readNextChunk()) {
        var binaryDigest = this.md5Buffer.end(true);
        var base64digest = btoa(binaryDigest);
        this.callback(null, base64digest);
      }
    }
  }, {
    key: "fileReaderDidError",
    value: function fileReaderDidError(event) {
      this.callback("Error reading ".concat(this.file.name));
    }
  }, {
    key: "readNextChunk",
    value: function readNextChunk() {
      if (this.chunkIndex < this.chunkCount || this.chunkIndex == 0 && this.chunkCount == 0) {
        var start = this.chunkIndex * this.chunkSize;
        var end = Math.min(start + this.chunkSize, this.file.size);
        var bytes = fileSlice.call(this.file, start, end);
        this.fileReader.readAsArrayBuffer(bytes);
        this.chunkIndex++;
        return true;
      } else {
        return false;
      }
    }
  }], [{
    key: "create",
    value: function create(file, callback) {
      var instance = new FileChecksum(file);
      instance.create(callback);
    }
  }]);

  return FileChecksum;
}();